
import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
import header1 from "@/components/headers/front-end-header.vue";
import footer1 from "@/components/footers/footer.vue";
import appConst from "@/lib/appConst";
import ProductList from "@/components/product-list.vue";
import PageRequest from "@/store/entities/page-request";

class PageProductRequest extends PageRequest {
  hash: string;
}

class SearchResultItem {
  uploadedFileName: string;
  hash: string;
}

@Component({
  components: { header1, footer1, ProductList }
})
export default class SearchByImage extends AbpBase {
  uploadedFileName: String = "";
  uploadingHeaders: any = {
    TenantId: Util.abp.multiTenancy.getTenantIdCookie()
  };
  searched: boolean = false;
  pagerequest: PageProductRequest = new PageProductRequest();
  searchResultItem: SearchResultItem = null;

  get list() {
    return this.$store.state.product.searchedByImageList;
  }
  get pageSize() {
    return this.$store.state.product.pageSize;
  }
  get totalCount() {
    return this.$store.state.product.totalCount;
  }
  get currentPage() {
    return this.$store.state.product.currentPage;
  }

  mounted() {
    this.$store.commit("product/setPageSize", 16);
    Util.setCurrentPageIndex(this);

    this.searchResultItem = JSON.parse(
      localStorage.getItem("SEARCH_BY_IMAGE")
    ) as SearchResultItem;

    if (this.searchResultItem) {
      this.uploadedFileName = this.searchResultItem.uploadedFileName;

      if (process.env.NODE_ENV === "production") {
        this.uploadedFileName = this.uploadedFileName.replace("http:", "https:");
      }

      this.getData(this.searchResultItem.hash);
    }
  }

  get uploadingUrl() {
    return appConst.apis.baseInfoApi + "/Product/SearchByImage";
  }

  handleBeforeUpload(file) {
    this.$Loading.start();

    var validationResult = Util.validateImageFile(file);
    if (!validationResult.result) {
      this.$Notice.warning({
        title: this.L("Tips"),
        desc: validationResult.msg
      });
      this.$Loading.error();
      return false;
    }
    return true;
  }

  handleUploaded(res, file) {
    this.searched = true;
    this.searchResultItem = res.result as SearchResultItem;
    this.uploadedFileName = this.searchResultItem.uploadedFileName;
    localStorage.setItem("SEARCH_BY_IMAGE", JSON.stringify(res.result));

    this.getData(res.result.hash);
    Util.changePageIndex(this, 1);
    this.$Loading.finish();
  }

  pageChange(page: number) {
    Util.changePageIndex(this, page);
  }

  getData(hash: string) {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.hash = hash;

    this.$store.dispatch({
      type: "product/getSearchedImageData",
      data: this.pagerequest
    });
  }
}
